export default __webpack_public_path__ + "static/xiaomi_store-e69c48ac02e97dd548dfdf350b9eaba1.jpg";